import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  Calendar, 
  Home,
  Plus
} from 'lucide-react';

interface SidebarProps {
  activePath: string;
  isMobileMenuOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ activePath, isMobileMenuOpen }) => {
  const sidebarItems = [
    { path: '/admin', label: 'Overview', icon: Home },
    { path: '/admin/meetings', label: 'Meetings', icon: Calendar }
  ];

  return (
    <div className="h-screen bg-white border-r border-[#D4AF37] flex flex-col shadow-sm w-16">
      <div className="flex-grow py-4">
        <ul className="space-y-4 px-2">
          {sidebarItems.map((item) => {
            const isActive = activePath === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center justify-center px-3 py-2.5 rounded-lg transition-all ${
                    isActive 
                      ? 'bg-[#D4AF37] text-white'
                      : 'hover:bg-[#F5E6C3]/20 text-gray-700 hover:text-[#D4AF37]'
                  }`}
                >
                  <item.icon size={20} />
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      
      <div className="p-4 border-t border-[#D4AF37]">
        <Link to="/admin/meetings/new">
          <Button 
            className="w-full aspect-square bg-[#D4AF37] hover:bg-[#BFA030] text-white transition-colors duration-200" 
            size="icon"
          >
            <Plus size={20} />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
